import React from "react";
import Modal from "../modal-new";
const icons = {
  delete: "/img/new-icons/red-trash.svg",
};
function ConfirmationModal(props) {
  const {
    title,
    contentText,
    cancelButtonText,
    cancelButtonAction,
    confirmButtonText,
    confirmButtonAction,
    isOpen,
    reduceSize,
    icon,
    confirmSuccess,
  } = props;

  if (!isOpen) {
    return null;
  }

  return (
    <Modal className={"confirmation-modal"} header={false}>
      <div className={reduceSize ? "reduced-confirmation-modal body" : "body"}>
        {icon && icons[icon] && (
          <div>
            <img src={icons[icon]} alt="delete icon" />
          </div>
        )}
        <h3>{title}</h3>
        <p>{contentText}</p>
      </div>
      <footer id="confirmation-modal-footer">
        <button data-button-type="secondary" onClick={cancelButtonAction}>
          <span>{cancelButtonText}</span>
        </button>
        <button
          data-button-type={confirmSuccess ? "primary" : "secondary"}
          data-action={confirmSuccess ? undefined : "cancel"}
          onClick={confirmButtonAction}
        >
          {confirmButtonText}
        </button>
      </footer>
    </Modal>
  );
}

export default ConfirmationModal;
